<topo-modal [isActive]="isActive" [backgroundCanClose]="true" (close)="onClose()">
  <div fxLayout="column" fxLayoutAlign="space-around center" style="padding-top: 30px">
    <div class="prompt-icon">
      <div style="position: relative; left: 20px; top: 20px">
        <i class="icon icon-delete_trash" style="font-size: 50px"></i>
      </div>
    </div>
    <div class="is-size-3" style="padding-top: 25px">
      <h5>{{ 'MANAGEMENT.DELETE-CONFIRMATION.ARE-YOU-SURE' | translate }}</h5>
    </div>
    <div style="padding-top: 25px; max-width: 350px">
      {{ 'MANAGEMENT.DELETE-CONFIRMATION.DO-YOU-REALLY' | translate }}
    </div>
    @if (itemNames) {
      <div class="item-names-container">
        <div fxLayout="column" fxLayoutAlign="center center">
          @for (item of itemNames; track item) {
            <div class="name-box">&quot;{{ item }}&quot;</div>
          }
        </div>
      </div>
    }
    <div style="padding-top: 25px; padding-bottom: 25px" fxLayout="row">
      <button class="button is-secondary is-medium" style="width: 150px; margin-right: 10px" (click)="cancelClick()">
        {{ 'MANAGEMENT.DELETE-CONFIRMATION.CANCEL' | translate }}
      </button>
      <button class="button is-danger is-medium" style="width: 150px" (click)="deleteClick()">
        {{ 'MANAGEMENT.DELETE-CONFIRMATION.DELETE' | translate }}
      </button>
    </div>
  </div>
</topo-modal>
